<template>
    <v-data-table
        class="elevation-0"
        :headers="headers"
        :items="items"
        :items-per-page="15"
        :footer-props="dataTableFooterProps"
        :search="dataTableSearch"
        :custom-filter="dataTableCustomFilter"
        :loading="isBusy"
        :loading-text="$t('common.loading_table_data')"
        :expanded.sync="expanded"
        show-expand
    >
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-text-field
                    v-model="dataTableSearch"
                    prepend-inner-icon="mdi-magnify"
                    :placeholder="$t('common.filter')"
                    outlined
                    dense
                    hide-details
                />
                <v-spacer/>
                <p class="mr-3 mt-2">
                    <v-icon>
                        {{ synchronizationIcon(synchronization) }}
                    </v-icon>
                    {{ synchronization ? $t('synchronization.status.' + synchronization.status) : '-' }}
                    ({{ synchronization ? $moment(synchronization.date_time).format('LLL') : '-' }})
                    <span v-if="synchronization && synchronization.status === 'error' && synchronization.error" class="error--text">
                        - {{ synchronization.error }}
                    </span>
                </p>
                <v-btn
                    v-if="!synchronization || (synchronization.status !== 'waiting' && synchronization.status !== 'synchronizing')"
                    color="success"
                    dark class="mb-2"
                    @click="onSynchronize"
                    :loading="isBusySynchronize"
                >
                    {{ $t('button.synchronize') }}
                </v-btn>
            </v-toolbar>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-3">
                <h3 class="overline">{{ $t('carriers.carrier_services') }}</h3>
                <v-data-table
                    class="elevation-0"
                    :headers="servicesHeaders"
                    :items="item.carrier_services"
                    :items-per-page="15"
                    :footer-props="dataTableFooterProps"
                    :search="dataTableSearch"
                    :custom-filter="dataTableCustomFilter"
                    :loading="isBusy"
                    :loading-text="$t('common.loading_table_data')"
                />
            </td>
        </template>
    </v-data-table>
</template>

<script>
import {API} from '@/api/api'
import SnackbarMixin from '@/mixins/SnackbarMixin'
import SynchronizationMixin from "@/mixins/SynchronizationMixin";
import DataTableMixin from "@/mixins/DataTableMixin";

export default {
    name: "CarriersTableComponent",
    mixins: [SnackbarMixin, SynchronizationMixin, DataTableMixin],
    data: () => ({
        // loading
        isBusyCarriers: false,
        isBusySynchronize: false,
        isBusySynchronization: false,
        // table data
        items: [],
        // synchronization data
        synchronization: null,
        // expanded table row
        expanded: []
    }),
    computed: {
        isBusy() {
            return this.isBusyCarriers || this.isBusySynchronize || this.isBusySynchronization;
        },
        headers() {
            return [
                {
                    text: this.$t('carriers.name'),
                    value: 'name'
                }
            ];
        },
        servicesHeaders() {
            return [
                {
                    text: this.$t('carriers.name'),
                    value: 'name'
                }
                // TODO: other columns
            ];
        }
    },
    methods: {
        fetchCarriers() {
            this.isBusyCarriers = true;
            API.get('/api/carriers')
                .then(response => {
                    this.items = response.data;
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyCarriers = false;
                });
        },
        fetchSynchronization() {
            this.isBusySynchronization = true;
            API.get('/api/synchronizations/carrier')
                .then(response => {
                    this.synchronization = response.data;
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusySynchronization = false;
                });
        },
        onSynchronize() {
            this.isBusySynchronize = true;
            API.post('/api/carriers/synchronize', [])
                .then(() => {
                    this.snackbarSuccess(this.$t('snackbar.carrier.synchronized'));
                    this.fetchCarriers();
                    this.fetchSynchronization();
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusySynchronize = false;
                });
        }
    },
    created() {
        this.fetchCarriers();
        this.fetchSynchronization();
    }
}
</script>
